/**
 * Labels for the last segment of the Single optimize breadcrumb:
 * Matching & AI → RoleFit AI → Candidate name → **{this}**
 */
export function getOptimizerFlowStepLabel(stepIndex: number): string {
  const labels: Record<number, string> = {
    0: 'Upload',
    1: 'Template',
    2: 'Resume review',
    3: 'Job',
    4: 'Match analysis',
    5: 'Optimize settings',
    6: 'Processing',
    7: 'Results',
    8: 'Download',
    9: 'Save',
    10: 'Apply',
    11: 'Tracking',
  };
  return labels[stepIndex] ?? `Step ${stepIndex + 1}`;
}
